export default class MyEventsSortListing {

    constructor(element) {

        this.sortWrapper = element;

        this.select = this.sortWrapper.querySelector(".my-events__utility-sort-select");

        this.list = document.querySelector(".my-events__list");

        // Only if there is more than 1 list item
        if (this.list.querySelectorAll(".my-events__item").length > 1) {
            this.init();
        }

    }

    sortChanged(event) {

        // Get selected sort attribute
        const sortAttributeSelected = event.target.value;

        // Deep clone the list of item DOM elements
        const sortedList = [...this.list.querySelectorAll(".my-events__item")];

        // We'll then sort by each list items data attribute which contains a JSON where properties match the sort attribute selected
        sortedList.sort((nodeA, nodeB) => { 

            const propertyA = nodeA.dataset[sortAttributeSelected].trim();

            const propertyB = nodeB.dataset[sortAttributeSelected].trim();

            return propertyA.localeCompare(propertyB, undefined, { numeric: true, sensitivity: 'base' });

        });

        // Clear out the list
        this.list.innerHTML = "";

        sortedList.forEach(function(item) {
            
            this.list.appendChild(item);

        }.bind(this));

    }
    
    init() {

        // Bind click event to button
        this.select.addEventListener("change", this.sortChanged.bind(this));

        this.select.disabled = false;
        
    }


}